export default angular.module('conduuApp.contentSlider', [])
  .directive('contentSlider', function($timeout, SettingsService) {
  return {
    template: require('./content-slider.directive.html'),
    restrict: 'E',
    scope: {
      settings: '@',
      public: '<',
      id: '@'
    },
    link: function (scope, element, attrs) {

      if (!scope.id) {
        scope.id = "contentslider" + Math.floor(Math.random() * 10000);
      }

      let METHOD = scope.public ? "getPublicByName" : "getByName";

      SettingsService[METHOD]({name: scope.settings}, config => {
        scope.data = config.data;

        $timeout(function () {

          $(document).ready(function () {

            $("#" + scope.id).owlCarousel({
              responsive: {
                0: {
                  items: 1
                },
                600: {
                  items: 1
                },
                1000: {
                  items: scope.data.items || 2
                }
              },
              dots: true,
              autoplay: true,
              loop: true,
              autoplaySpeed: 1000,
              autoplayTimeout: scope.data.speed || 5000,
              autoplayHoverPause:true
            });

          });

        });
      });

    }
  };
})
  .name;



// WEBPACK FOOTER //
// ./client/components/content-slider/content-slider.directive.js